import React from 'react';
import { Navbar, Nav } from 'rsuite';
import ArrowLeftLineIcon from '@rsuite/icons/ArrowLeftLine';
import ArrowRightLineIcon from '@rsuite/icons/ArrowRightLine';
import MenuIcon from '@rsuite/icons/Menu';
import Brand from '../Brand';
import { Link } from 'react-router-dom';


interface NavToggleProps {
  expand?: boolean;
  onChange?: () => void;
}



const NavToggle = ({ expand, onChange }: NavToggleProps) => {
  return (
    <Navbar appearance="subtle" className="nav-toggle">
      
      <Nav pullRight>
      
      
        <Nav.Item
        
          onClick={onChange}
          style={{ textAlign: 'center' }}
          className='nav-toggle3'
          icon={expand ? <Brand/> : <MenuIcon />}
          
        />
         <Nav.Item
        
        onClick={onChange}
        style={{ textAlign: 'center' }}
        icon={expand ? <MenuIcon/> : <Brand />}
        className='nav-toggle2'
        
      />
        
      </Nav>
      
    </Navbar>
  );
};

export default NavToggle;
